import React, { CSSProperties } from 'react'
import { Spinner } from '@cjdev-internal/visual-stack-x/Spinner';
import { FetchingIndicatorProps, FetchingIndicatorComponent } from '../../../types';
import './index.css'

const DefaultSpinner: FetchingIndicatorComponent = ({ size = 'large' }: FetchingIndicatorProps) => {
  return (
    <div className="default-spinner-container" >
      <Spinner size={size} />
    </div>
  );
};

export default DefaultSpinner;